/**
 * 문서 인라인 미리보기 URL 유틸.
 *
 * 지식저장소(BookStack) 첨부 링크(/attachments/{id})는 클릭하면 다운로드된다.
 * rag-service 의 /preview/{id} 는 같은 첨부를 PDF(또는 원본 이미지)로 inline 응답하므로,
 * 뷰어(iframe)에서는 이 URL 로 바꿔서 열어야 문서가 바로 보인다.
 */

/** 지식저장소 첨부 URL → 미리보기 URL. 첨부 링크가 아니면 null. */
export function attachmentPreviewUrl(url: string): string | null {
  if (!url) return null;
  try {
    const u = new URL(url, window.location.href);
    const m = u.pathname.match(/\/attachments\/(\d+)\/?$/);
    if (!m) return null;
    return `${u.origin}/preview/${m[1]}`;
  } catch {
    return null;
  }
}

/** 뷰어에 실제로 넣을 URL — 첨부면 미리보기 URL, 그 외(문서 페이지 등)는 원본 그대로. */
export function viewerUrl(url: string): string {
  return attachmentPreviewUrl(url) ?? url;
}
